import { render, staticRenderFns } from "./Materi.vue?vue&type=template&id=3da11e18&scoped=true"
import script from "./Materi.vue?vue&type=script&lang=js"
export * from "./Materi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da11e18",
  null
  
)

export default component.exports